var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPs3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 158,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M82.49 156.491c.72.753 1.993.334 2.126-.698.854-6.595 3.018-24.444 3.018-36.124 0-14.557-9.535-13.221-9.535-35.36 0-22.14 5.051-43.492 5.051-43.492-.783 0-32.309-1.615-63.89-24.775 0 0-5.42 23.008-5.42 45.147 0 22.14 9.536 20.804 9.536 35.36 0 11.985-2.275 30.457-3.08 36.615a1.24 1.24 0 0 0 1.68 1.317l28.765-11.127 31.752 33.133-.003.004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF465",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "m28.88 123.023-.986 9.167m4.178-10.447-.987 9.171m4.178-10.447-.984 9.172m4.176-10.45-.983 9.168m4.178-10.447-.984 9.171m4.173-10.449-.983 9.167m4.177-10.447-.983 9.171m4.174-10.448-.984 9.171m3.965-6.091-.95 8.83m3.928-5.748-.953 8.856m3.934-5.775-.954 8.882m3.932-5.803-.954 8.908m3.937-5.823-.958 8.93m3.935-5.849-.958 8.919m3.938-5.84-.965 8.982m3.947-5.9-.968 9.008m4.043-6.135-.988 9.168"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.455,
    d: "M74.943 39.837c-10.358-1.741-29.206-6.485-48.94-19.163-1.244 5.782-5.03 24.882-5.03 43.384 0 22.143 9.536 20.803 9.536 35.36 0 7.141-.81 15.834-1.633 23.606l22.317-8.938 26.942 27.51c.828-7.798 1.648-17.325 1.648-24.515 0-14.556-9.535-13.22-9.535-35.36 0-18.542 3.541-36.525 4.692-41.884h.003Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M81.552 42.29c-4.896 2.487-11.495 7.045-8.608 11.97 2.65 4.513 8.608-11.97 8.608-11.97ZM20.094 19.512s.694 7.501 1.065 12.883c.372 5.382-2.683 10.938-4.669 13.031l3.608-25.914h-.004Zm.544-.605c.89 5.98 3.719 6.35 3.633 4.383-.1-2.316-3.633-4.383-3.633-4.383Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "M82.49 156.491c.72.753 1.993.334 2.126-.698.854-6.595 3.018-24.444 3.018-36.124 0-14.557-9.535-13.221-9.535-35.36 0-22.14 5.051-43.492 5.051-43.492-.783 0-32.309-1.615-63.89-24.775 0 0-5.42 23.008-5.42 45.147 0 22.14 9.536 20.804 9.536 35.36 0 11.985-2.275 30.457-3.08 36.615a1.24 1.24 0 0 0 1.68 1.317l28.765-11.127 31.752 33.133-.003.004Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "M84.506 39.804c0 .917-.75 1.67-1.67 1.67-.92 0-1.67-.75-1.67-1.67v-1.978h3.337v1.978h.003ZM21.505 15.515c0 .917-.75 1.67-1.67 1.67-.921 0-1.67-.75-1.67-1.67v-1.978H21.5v1.978h.003Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "M7.289 6.646c.77-2.115.243-4.248-1.177-4.765-1.42-.517-3.194.779-3.964 2.894S1.905 9.023 3.324 9.54c1.42.517 3.195-.779 3.965-2.894Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "M94.515 33.323 6.9 3.712c-.913-.334-2.056.5-2.55 1.86-.494 1.358-.156 2.731.757 3.065l86.15 33.634C143.837 62.8 159.08 78.53 154.745 90.44l9.684-26.605 9.683-26.604c-4.335 11.91-26.118 14.163-79.598-3.912v.004Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M90.667 38.553 5.115 6.901c.011.182.045.36.112.527.11.264.323.32.567.416l82.701 32.287c28.138 10.986 53.321 23.253 61.827 33.641l.958-12.797S121.328 49.896 90.667 38.55v.004Zm53.401 26.735c-11.186-7.07-7.682-6.417.067-2.543 8.481 4.239 7.947 7.61-.067 2.543Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAEFE",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.455,
    d: "M183.561 70.803c5.692-15.639 1.695-31.451-8.928-35.318-10.623-3.866-23.849 5.677-29.541 21.316-5.692 15.64-1.695 31.452 8.928 35.318 10.623 3.867 23.849-5.677 29.541-21.316Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1C",
    d: "M182.259 70.209c5.348-14.693 1.684-29.516-8.184-33.108-9.868-3.591-22.203 5.408-27.551 20.101-5.348 14.694-1.684 29.516 8.184 33.108 9.868 3.592 22.203-5.408 27.551-20.101Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "M156.483 46.47c10.237-.497 15.685-3.897 17.627-9.234m-26.936 34.803c7.523 6.959 9.513 13.064 7.568 18.405"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.455,
    d: "M172.687 66.846c3.65-10.028 1.148-20.144-5.588-22.596-6.736-2.452-15.155 3.69-18.805 13.718-3.65 10.028-1.148 20.144 5.588 22.596 6.736 2.452 15.155-3.69 18.805-13.718Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.455,
    d: "M156.142 46.726c.583.04 1.158.16 1.715.36 4.702 1.711 6.45 8.778 3.901 15.782-2.55 7.003-8.429 11.294-13.132 9.583a6.347 6.347 0 0 1-1.544-.824m4.078-19.415c.289 1.967.059 4.246-.769 6.518-.827 2.271-2.115 4.164-3.6 5.486"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#48FF91",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "M151.163 52.212c16.665 3.2 25.469.379 32.48-3.585m-36.852 15.592c14.824 8.262 20.321 15.689 23.142 23.23m12.36-17.106L148.291 57.97m7.693-15.334c.502 1.934-.668 4.487-2.1 6.135m-9.557 25.885c1.626-1.161 2.372-3.867 2.335-6.05"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#48FF91",
    stroke: "#0500FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.455,
    d: "M18.903 7.773c-1.036-.379-2.331.568-2.891 2.112-.442 1.217-.297 2.468.293 3.129l4.134 1.614c-.824-.534-1.095-1.937-.586-3.337.497-1.362 1.596-2.371 2.557-2.33l-3.507-1.184v-.004Zm64.414 21.769c-1.618-.352-3.344 1.043-4.208 3.411-.683 1.878-.472 3.675.367 4.725l4.576 1.785c-.827-1.102-.983-3.032-.3-4.906.909-2.498 2.85-3.946 4.528-3.337l-4.966-1.678h.003Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 48.533,
    x2: 56.186,
    y1: 92.374,
    y2: 78.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 55.651,
    x2: 46.268,
    y1: 73.222,
    y2: 93.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2.146,
    x2: 7.291,
    y1: 4.778,
    y2: 6.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 84.511,
    x2: 86.169,
    y1: 34.371,
    y2: 29.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs3);
export default __webpack_public_path__ + "static/media/ps-3.431d0b691cb887c4ddb639e3b137eb4f.svg";
export { ForwardRef as ReactComponent };